import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-skeleton-new-principal-image',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './skeleton-new-principal-image.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SkeletonNewPrincipalImageComponent {}
